import * as React from "react";

function SvgIcons8SmartWatch(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#37474f"
        d="M34 12H12c3.1-2.5 3.8-5.4 4-6.9.1-.7.6-1.2 1.2-1.4 1.3-.3 3.4-.7 5.8-.7s4.5.4 5.8.7c.7.1 1.2.7 1.2 1.4.2 1.5.9 4.4 4 6.9zm0 24H12c3.1 2.5 3.8 5.4 4 6.9.1.7.6 1.2 1.2 1.4 1.3.3 3.4.7 5.8.7s4.5-.4 5.8-.7c.7-.2 1.1-.7 1.2-1.4.2-1.5.9-4.4 4-6.9z"
      />
      <path
        fill="#c5cae9"
        d="M30 38H16c-2.8 0-5-2.3-5-5V15c0-2.8 2.3-5 5-5h14c2.8 0 5 2.3 5 5v18c0 2.8-2.2 5-5 5z"
      />
      <path
        fill="#263238"
        d="M29.7 36H16.3c-1.8 0-3.3-1.5-3.3-3.3V15.3c0-1.8 1.5-3.3 3.3-3.3h13.4c1.8 0 3.3 1.5 3.3 3.3v17.4c0 1.8-1.5 3.3-3.3 3.3z"
      />
      <path fill="#fff" d="M23 21.5a2.5 2.5 0 100 5 2.5 2.5 0 100-5z" />
      <path
        fill="#ffab00"
        d="M17 22c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm10 2c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
      />
      <path fill="#76ff03" d="M26 27a2 2 0 100 4 2 2 0 100-4z" />
      <path fill="#00e5ff" d="M20 27a2 2 0 100 4 2 2 0 100-4z" />
      <path fill="#64b5f6" d="M26 17a2 2 0 100 4 2 2 0 100-4z" />
      <path fill="#ff1744" d="M20 17a2 2 0 100 4 2 2 0 100-4z" />
      <path fill="#ffd740" d="M15 28a1 1 0 100 2 1 1 0 100-2z" />
      <path
        fill="#fff"
        d="M15 18c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm15 11c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z"
      />
      <path
        fill="#455a64"
        d="M13.3 14c.3.6 1 1 1.7 1h16c.7 0 1.4-.4 1.7-1-.5-1.2-1.7-2-3-2H16.3c-1.3 0-2.5.8-3 2z"
      />
      <path
        fill="#9fa8da"
        d="M34.999 22c1.063 0 1-1 1-1v-4s.063-1-1-1c-.825 0-1 2.031-1 3s.175 3 1 3z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8SmartWatch);
